import { render, staticRenderFns } from "./RelatorioIndividual.vue?vue&type=template&id=a042752e&scoped=true&"
import script from "./RelatorioIndividual.vue?vue&type=script&lang=js&"
export * from "./RelatorioIndividual.vue?vue&type=script&lang=js&"
import style0 from "./RelatorioIndividual.vue?vue&type=style&index=0&id=a042752e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a042752e",
  null
  
)

export default component.exports